module.exports = __webpack_public_path__ + "static/media/sm.16dab5ad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/sm.svg
// module id = 249
// module chunks = 0